import React, { useState, useImperativeHandle, forwardRef } from 'react'
import ReactDOM from 'react-dom'
import Map from '../../dashboard/partials/LocationMap'
import { trans } from '../../../../_providers/Translation'
import '../../../../assets/css/schedule.css'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"

function TechLocationModal(props, ref) {
    const [visible, setVisible] = useState(false)

    useImperativeHandle(ref, () => ({
        open: () => setVisible(true),
        close: () => setVisible(false)
    }), [])




    return (
        <div className={`${visible ? 'visible' : ''} overlay`}>
            <div className={`${visible ? 'show' : ''} popup-primary`}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('random.employeesLocation')}
                        </h2>
                        <p>
                            {trans('random.employeesLocationDesc') || 'Преглед на текущите местоположения на техниците'}
                        </p>
                    </div>
                    <span
                        className='close'
                        onClick={() => {
                            setVisible(false)
                        }}
                    >

                    </span>
                </div>
                <Map mapId="tech-location-map" mapStyle={{ width: '100%', height: 'calc(100vh - 200px)' }} enableGeofence onHide={() => setVisible(false)} />
            </div>
        </div>
    )
}

export default forwardRef(TechLocationModal)